import { render, staticRenderFns } from "./ShozokuMasterDetails.vue?vue&type=template&id=6f034a41"
import script from "./ShozokuMasterDetails.vue?vue&type=script&lang=js"
export * from "./ShozokuMasterDetails.vue?vue&type=script&lang=js"
import style0 from "./ShozokuMasterDetails.vue?vue&type=style&index=0&id=6f034a41&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports